import React, { useState } from 'react';
import { Button, Form, Modal } from 'antd';
import { observer } from 'mobx-react';
import FormComponent from './FormComponent';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';

const AddComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const { ADMINUSER } = useStore();
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);

	const handleSubmit = (data) => {
		setSaving(true);
		delete data.cn_password;
		ADMINUSER.addAdminUser(data)
			.then((data) => {
				Notification.success({
					message: Message().CRUD.ADD('User'),
				});
				closeModal();
			})
			.catch((e) => {})
			.finally(() => setSaving(false));
	};

	const handleChange = async (s) => {
		form.validateFields({ validateOnly: true })
			.then(() => {
				setDisabled(false);
			})
			.catch(() => {
				setDisabled(true);
			});
	};

	const closeModal = () => {
		form.resetFields();
		onClose();
	};
	return (
		<Modal
			title="Add User"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'500px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="AddForm"
					>
						Add User
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<FormComponent
				id="AddForm"
				form={form}
				onFinish={handleSubmit}
				handleChange={handleChange}
			/>
		</Modal>
	);
});

export default AddComponent;
